function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,255.999C512,133.046,412.344,33.39,289.391,33.39c-119.929,0-217.675,94.819-222.411,213.585l-28.978-28.978     c-8.693-8.693-22.788-8.693-31.482,0c-8.693,8.693-8.693,22.788,0,31.482l66.783,66.783c8.693,8.693,22.788,8.693,31.482,0     l66.783-66.783c8.693-8.693,8.693-22.788,0-31.482c-8.693-8.693-22.788-8.693-31.482,0l-28.53,28.53     c4.923-93.959,82.649-168.615,177.836-168.615c98.364,0,178.087,79.723,178.087,178.087c0,0.469,0.019,0.933,0.048,1.394     c-0.037,0.476-0.084,0.949-0.092,1.435c-0.2,13.245-1.87,26.424-4.964,39.201c-2.872,11.954,4.497,23.975,16.451,26.847     c1.759,0.423,3.495,0.623,5.231,0.623c10.04,0,19.144-6.856,21.615-17.052c3.851-15.939,5.921-32.39,6.189-48.929     c0.009-0.553-0.009-1.099-0.04-1.643C511.967,257.256,512,256.632,512,255.999z",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.908,365.035c-9.55-7.769-23.552-6.278-31.299,3.272c-8.281,10.195-17.742,19.523-28.138,27.693     c-9.661,7.591-11.309,21.593-3.74,31.254c4.408,5.588,10.93,8.504,17.519,8.504c4.808,0,9.683-1.558,13.757-4.764     c12.978-10.218,24.821-21.882,35.172-34.638C469.927,386.806,468.458,372.782,458.908,365.035z",
    fill: "#7f7f7f",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.659,429.747c-12.8,2.872-26.001,4.341-39.268,4.341c-12.31,0-22.261,9.973-22.261,22.261     c0,12.288,9.951,22.261,22.261,22.261c16.54,0,33.035-1.825,49.041-5.432c11.999-2.694,19.523-14.603,16.829-26.602     S340.591,427.098,328.659,429.747z",
    fill: "#7f7f7f",
    "data-original": "#000000",
    style: {},
    className: ""
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default ForwardRef;